// extracted by mini-css-extract-plugin
export default {"section05":"Section05_section05__UhsFc","section05Container":"Section05_section05Container__j9ctu"};